<template>
  <div>
    <el-main style="background-color: white;border-radius: 10px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-input size="small" @keyup.enter.native="selectUser(1)" v-model="searchName" placeholder="请输入用户姓名"
                    clearable></el-input>
        </el-col>
        <el-col :span="12">
          <el-button size="small" type="primary" @click="selectUser(1)">筛选用户</el-button>
          <el-button v-if="isSearchState" size="small" plain @click="cancelFilter">取消筛选</el-button>
        </el-col>
      </el-row>

      <el-table
        ref="multipleTable"
        :data="userList"
        size="small"
        height="466"
        border
        tooltip-effect="dark"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        style="margin-top: 20px;width: max-content;"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="count"
          label="编号"
          width="60">
        </el-table-column>
        <el-table-column label="头像" prop="headPortrait" width="85">
          <template slot-scope="scope">
            <img :src="scope.row.headPortrait" height="60px" width="60px"
                 style="border-radius: 50%">
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="昵称"
          width="90">
        </el-table-column>
        <el-table-column
          prop="account"
          label="登录账号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="password"
          label="登录密码"
          width="120">
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱"
          width="170">
        </el-table-column>
<!--        <el-table-column
          prop="recentLoginAddress"
          label="最近登录位置"
          width="170">
        </el-table-column>-->
        <el-table-column
          prop="recentLogin"
          label="最近登录"
          width="85">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="注册时间"
          width="170">
        </el-table-column>
        <el-table-column
          prop="updateTime"
          width="170"
          label="上次更新时间">
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              size="small"
              @click="handleEdit(scope.$index, scope.row)">编辑
            </el-button>
            <el-button
              size="small"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px">
        <el-button size="small" @click="deleteSelectUserList()">删除选中的记录</el-button>
      </div>

      <el-pagination
        style="margin-top: 10px"
        background
        layout="total,prev, pager, next,jumper"
        :page-size="5"
        :current-page.sync="page.switchPage"
        @current-change="pageChange"
        :total="page.totalCount">
      </el-pagination>

      <!--编辑框      -->
      <el-dialog :lock-scroll="false" :close-on-click-modal="false" :close-on-press-escape="false" title="修 改 用 户"
                 width="500px" :visible.sync="editDialogVisible"
                 @close="cancel('editForm')"
                 centerp center top="10%">
        <el-form :model="editForm" status-icon :rules="editRules" ref="editForm" label-width="100px"
                 class="demo-ruleForm"
                 style="margin-left: 20px;">
          <el-form-item label="头像：" prop="headPortrait">
            <el-upload
              v-model="editForm.headPortrait"
              class="avatar-uploader"
              :action="uploadActionUrl+'/uploadImage'"
              name="image"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess">
              <img v-if="editForm.headPortrait" :src="editForm.headPortrait" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="昵称：" prop="name">
            <el-input v-model="editForm.name" placeholder="由汉字或字母数字组成" maxlength="10"
                      show-word-limit type="text" size="medium"
                      style="width: 240px"></el-input>
          </el-form-item>
          <!--          <el-form-item label="登录账号：" prop="account">
                      <el-input v-model="editForm.account" placeholder="由数字组成" maxlength="11"
                                show-word-limit type="text" size="medium"
                                style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="登录密码：" prop="password">
                      <el-input v-model="editForm.password" placeholder="字母数字下划线" maxlength="16"
                                show-word-limit type="text" size="medium"
                                style="width: 240px"></el-input>
                    </el-form-item>-->
          <el-form-item label="邮箱：" prop="email">
            <el-input v-model="editForm.email" placeholder="请输入邮箱" clearable type="text" size="medium"
                      style="width: 240px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="sure('editForm')">确定</el-button>
            <el-button size="small" @click="cancel('editForm')">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

    </el-main>
  </div>
</template>

<script>
import request from "../../utils/axiosUtils";
import base_url from "../../utils/Constants";

export default {
  name: "UserManager",
  data() {
    //姓名验证
    let nameValidate = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error("昵称不能为空"))
      }
      let nameCheck = /^[\u2E80-\u9FFFa-zA-Z0-9]{1,10}$/;
      if (!nameCheck.test(value)) {
        return callback(new Error('姓名格式有误'));
      }
      callback()
    };
    //账号验证
    /*let accountValidate = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error("账号不能为空"))
      }
      let nameCheck = /^[0-9]{1,11}$/;
      if (!nameCheck.test(value)) {
        return callback(new Error('账号格式有误'));
      }
      callback()
    };*/
    //密码验证
    /*let passwordValidate = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('密码不能为空'));
      } else {
        let passwordCheck = /^[a-zA-Z0-9_]{1,16}$/;
        if (!passwordCheck.test(value)) {
          return callback(new Error('密码格式有误'));
        }
      }
      callback()
    };*/
    //邮箱验证
    let emailValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱不能为空'));
      } else {
        let emailCheck = /^([a-z0-9_.-]+)@([\da-z.-]+)\.([a-z.]{2,6})$/;
        if (!emailCheck.test(value)) {
          return callback(new Error('邮箱格式有误'));
        }
      }
      callback()
    };
    return {
      //管理员信息
      adminInfo: {},
      //需要搜索的名称
      searchName: '',
      //当前是否为搜索状态,默认false
      isSearchState: false,
      //页面
      page: {
        switchPage: 1,
        currentPage: 1,
        totalCount: 0,
      },
      //用户列表
      userList: [
        {
          count: null,
          id: null,
          headPortrait: null,
          name: null,
          account: null,
          password: null,
          email: null,
          recentLogin: null,
          createTime: null,
          updateTime: null,
        },
      ],
      //选中的用户列表
      selectUserList: [],
      //编辑弹窗是否打开状态
      editDialogVisible: false,
      //编辑框字段
      editForm: {
        id: '',
        headPortrait: '',
        name: '',
        /*        password: '',
                account:'',*/
        email: '',
      },
      editRules: {
        headPortrait: [
          {required: true, message: '头像不能为空', trigger: 'blur'}
        ],
        name: [
          {required: true, validator: nameValidate, trigger: 'blur'}
        ],
        /*account: [
          {required: true, validator: accountValidate, trigger: 'blur'}
        ],
        password: [
          {required: true, validator: passwordValidate, trigger: 'blur'}
        ],*/
        email: [
          {required: true, validator: emailValidate, trigger: 'blur'}
        ],
      },
      //图片上传路径
      uploadActionUrl: base_url

    }
  },
  methods: {
    //查询用户,条件包含昵称的用户
    selectUser(page) {
      let searchName = this.searchName;
      if (searchName !== '') {
        this.page.currentPage = page
        this.page.switchPage = page
        request({
          url: '/user/searchName',
          method: 'get',
          params: {
            page: this.page.currentPage,
            name: searchName,
            adminInfo: this.adminInfo
          }
        }).then(response => {
          // console.log(response)
          if (response.data.flag) {
            this.isSearchState = true;
            this.userList = this.handlerUserInfo(response.data.data.users)
            this.page.totalCount = response.data.data.totalCount;
            this.$notify({
              title: '查询',
              message: '查询成功',
              type: 'success',
              duration: '1000',
            });
          } else {
            this.isSearchState = true;
            this.userList = null
            this.page.totalCount = 0
            this.$notify({
              title: '查询',
              message: '找不到类似数据',
              type: 'error',
              duration: "2000",
            });
          }
        });
      } else {
        this.$notify({
          title: '查询',
          message: '请输入用户名',
          type: 'error',
          duration: '1400',
        });
      }
    },
    //取消筛选
    cancelFilter() {
      this.isSearchState = false;
      this.searchName = ''
      this.getUserList();
    },
    //批量删除选中的用户列表
    deleteSelectUserList() {
      let that = this;
      if (this.selectUserList.length === 0) {
        this.$notify.error({
          title: '批量删除用户',
          duration: 4000,
          message: '请选择要删除的项'
        });
        return
      }
      this.$confirm('此操作将逻辑删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let selectUserIds = '';//选中的用户id数组
        let selectUserListLength = this.selectUserList.length;
        for (let i = 0; i < selectUserListLength; i++) {
          if (i !== 0)
            selectUserIds += "&ids=" + this.selectUserList[i].id;
          else
            selectUserIds += "ids=" + this.selectUserList[i].id;
        }
        request({
          url: '/user/deleteUserByIds?' + selectUserIds,
          method: 'get',
          params: {
            adminInfo: this.adminInfo
          }
        }).then(response => {
          // console.log(response);
          if (response.data.flag) {
            if (selectUserListLength === this.userList.length && this.page.currentPage > 1)
              this.page.currentPage -= 1
            if (this.isSearchState) {
              this.selectUser(this.page.currentPage)
            } else {
              this.getUserList()
            }
            this.$message({
              type: 'success',
              message: response.data.message
            });
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            });
          }
        })
        this.$refs.multipleTable.clearSelection();

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    handleSelectionChange(val) {
      this.selectUserList = val;
    },
    //处理删除单个用户
    handleDelete(index, data) {
      // console.log(index, data);
      this.$confirm('此操作将逻辑删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/user/deleteUserById',
          method: 'get',
          params: {
            id: data.id,
            adminInfo: this.adminInfo
          }
        }).then(response => {
          // console.log(response)
          if (response.data.flag) {
            if (this.userList.length === 1 && this.page.currentPage > 1) {
              this.page.currentPage -= 1
            }
            if (this.isSearchState) {
              this.selectUser(this.page.currentPage)
            } else {
              this.getUserList()
            }
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '删除失败!'
            });
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    handleTime(date) {
      let time = new Date(
        date.substr(0, 4),
        parseInt(date.substr(5, 2)) - 1,
        date.substr(8, 2),
        date.substr(11, 2),
        date.substr(14, 2),
        date.substr(17, 2),
      );
      let year = time.getFullYear();
      let month = this.handleZero(time.getMonth() + 1);
      let day = this.handleZero(time.getDate());
      let hours = this.handleZero(time.getHours());
      let minutes = this.handleZero(time.getMinutes());
      let seconds = this.handleZero(time.getSeconds());
      return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
    },
    handleZero(time) {
      if (time < 10) {
        return '0' + time;
      } else {
        return time
      }
    },
    //处理最近登录时间
    handleRecentLoginTime(date) {
      let currentTime = new Date().getTime();
      let recentTime = new Date(
        date.substr(0, 4),
        parseInt(date.substr(5, 2)) - 1,
        date.substr(8, 2),
        date.substr(11, 2),
        date.substr(14, 2),
        date.substr(17, 2),
      ).getTime();
      let time = currentTime - recentTime;
      let seconds = parseInt(time / 1000 + "");//秒
      // console.log(date,new Date(recentTime), currentTime, recentTime, seconds)
      let targetTime = null;
      if (seconds >= 60 * 60 * 24 * 30 * 12) {//31,104,000
        targetTime = parseInt(seconds / (60 * 60 * 24 * 30 * 12)) + "年前";
      } else if (seconds >= 60 * 60 * 24 * 30) {//2,592,000
        targetTime = parseInt(seconds / (60 * 60 * 24 * 30)) + "月前";
      } else if (seconds >= 60 * 60 * 24) {//86,400
        targetTime = parseInt(seconds / (60 * 60 * 24)) + "天前";
      } else if (seconds >= 60 * 60) {//3,600
        targetTime = parseInt(seconds / (60 * 60)) + "小时前";
      } else if (seconds >= 60) {//60
        targetTime = parseInt(seconds / 60) + "分前";
      } else {
        targetTime = seconds + "秒前";
      }
      return targetTime;
    },
    //处理用户信息
    handlerUserInfo(userList) {
      let count = (this.page.currentPage - 1) * 5 + 1;
      userList.forEach(data => {
        data.count = count++;
        data.headPortrait = base_url+'/getImage/' + data.headPortrait;
        //上次登录时间
        data.recentLogin = this.handleRecentLoginTime(data.recentLogin)
        //创建时间
        data.createTime = this.handleTime(data.createTime)
        //更新时间
        data.updateTime = this.handleTime(data.updateTime)
      })
      return userList;
    },
    //获取用户数据
    getUserList() {
      let userList;
      let that = this;
      // console.log(this.adminInfo)
      request({
        url: '/user/getUser',
        method: 'get',
        params: {
          page: this.page.currentPage,
          adminInfo: this.adminInfo
        }
      }).then(response => {
        // console.log(response)
        userList = response.data.data;
        that.userList = this.handlerUserInfo(userList);
      })
      //获取用户的记录数
      request({
        url: '/user/getUserInfoCount',
        method: 'get',
        params: {
          adminInfo: this.adminInfo
        }
      }).then(response => {
        that.page.totalCount = response.data.data;
      })
    },
    //当前页改变的方法
    pageChange(value) {
      this.page.currentPage = value;
      if (this.isSearchState) {
        this.selectUser(this.page.currentPage)
      } else {
        this.getUserList()
      }
    },
    //处理编辑单个用户
    handleEdit(index, data) {
      // console.log(index, data);
      //初始化字段
      this.editForm.id = data.id;
      this.editForm.name = data.name;
      /*      this.editForm.account = data.account;
            this.editForm.password = data.password;*/
      this.editForm.headPortrait = data.headPortrait;
      this.editForm.email = data.email;
      //显示对话框
      this.editDialogVisible = true
    },
    //处理头像之前
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else if (isPng) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
        return false;
      }
    },
    //处理头像成功
    handleAvatarSuccess(result) {
      // console.log(result)
      if (result.flag) {
        this.editForm.headPortrait = result.data;
      } else {
        this.$notify.error({
          title: '图片错误',
          duration: 6000,
          message: result.message
        });
      }
    },
    //确定修改用户信息
    sure(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('此操作将修改用户登录信息,我们不建议这样做, 是否继续?', '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            request({
              url: '/user/updateUserInfo',
              method: 'post',
              params: {
                userInfo: that.editForm,
                adminInfo: this.adminInfo
              }
            }).then(response => {
              // console.log(response, response.data.flag)
              if (response.data.flag) {
                this.$notify.success({
                  title: '修改',
                  duration: 2000,
                  message: response.data.message,
                });
                if (this.isSearchState) {
                  this.selectUser(this.page.currentPage)
                } else {
                  this.getUserList()
                }
                that.editDialogVisible = false;
              } else {
                this.$notify.error({
                  title: '修改',
                  duration: 4000,
                  message: response.data.message,
                });
              }
            })
          }).catch(() => {
            this.$message({
              type: 'success',
              message: '已取消'
            });
          });
        }
      });
    },
    //取消修改用户信息
    cancel(formName) {
      this.$refs[formName].resetFields();
      this.editDialogVisible = false;
    }
  },
  mounted() {
    let adminInfo = JSON.parse(window.sessionStorage.getItem("adminInfo"));
    this.adminInfo = adminInfo;
    this.getUserList()
  }
}
</script>


<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 130px;
  text-align: center;
}

.avatar {
  width: 130px;
  height: 130px;
  display: block;
}
</style>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/UserManager.vue